import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoadingService } from '../../../loading/loading.service';
import { highwayI } from 'src/app/modules/@types/hightway.interface';
import { catchError, debounceTime, distinctUntilChanged, finalize, of, switchMap } from 'rxjs';
import { MunicipalitiesService } from 'src/app/modules/services/municipalities/municipalities.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HighwaysService } from 'src/app/modules/services/highways/highways.service';
import { AlertComponent } from '../../../alert/alert.component';

@Component({
  selector: 'app-cad-highway-modal',
  templateUrl: './cad-highway-modal.component.html',
  styleUrls: ['./cad-highway-modal.component.scss']
})
export class CadHighwayModalComponent implements OnInit {
  isEditMode: boolean = false;
  highway!: any;
  form: any;
  searchText: string = '';
  selectedOptionMunicipios: any;
  filteredOptionsMunicipios: any[] = [];
  searchControlMunicipiosHeader = new FormControl();
  searchControlHighwayHeader = new FormControl(null, [Validators.required]);
  descriptionHighwayHeader = new FormControl();
  selectedOptionHighway: any;
  filteredOptionsHighway: any[] = [];
  constructor(
    private _fb: FormBuilder,
    private dialogRef: MatDialogRef<CadHighwayModalComponent>,
    private municipioService: MunicipalitiesService,
    @Inject(MAT_DIALOG_DATA) public uploadData: any,
    private dialog: MatDialog,
    private highWayService: HighwaysService,
    private _snackBar: MatSnackBar,
    private loadingService: LoadingService,
  ) {
    this.isEditMode = this.uploadData.isEditMode;
    if(!this.isEditMode){
      this.form = this._fb.group({
        name: ['', Validators.required],
        description: [''],
      })
  
    }else{
      this.form = this._fb.group({
        description: [''],
      })
    }
  
  }

  ngOnInit(): void {
    this.isEditMode = this.uploadData.isEditMode
    this.highway = this.uploadData.highWay
    this.searchText = this.uploadData.searchText

    this.searchControlHighwayHeader.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((value: any) =>
      {
      
        if(value.length <= 0){
          this.searchControlHighwayHeader.setValue( null, { emitEvent: false })
          this.selectedOptionHighway = null;
        }
        return this.highWayService.getAll(0, '', '', value).pipe(
          catchError((error) => {
            return of([]);
          })
        )
      }
       
      )
    ).subscribe(
      {
        next: (results: any) => {
          this.filteredOptionsHighway = results.content;

          if (this.filteredOptionsHighway?.length === 0 || this.filteredOptionsHighway === undefined) {
            this.filteredOptionsHighway = []

            this.filteredOptionsHighway.push({ addNew: true });
          }
          if (results?.content?.length) {
            this.filteredOptionsHighway = results.content;
          } else {
            this.filteredOptionsHighway = [];
            this.filteredOptionsHighway = [{ addNew: true }];
          }
        }, error: (err: any) => {
          this.filteredOptionsHighway = [];
          this.filteredOptionsHighway = [{ addNew: true }];
        }
      }
    );

    if (this.isEditMode) {
      this.selectedOptionHighway = this.highway.highway;
      this.descriptionHighwayHeader.setValue(this.highway.description ? this.highway.description : null)
      this.searchControlHighwayHeader.setValue(this.highway.highway.name, { emitEvent: false })
    }
  }

  onSubmit() {

    if (this.isEditMode) {
      const data = {
        highwayCoveredId: this.highway.id,
        highwayId: this.selectedOptionHighway.id,
        description: this.descriptionHighwayHeader.value,
        name:this.form.value.name
      }
      this.dialogRef.close(data)
    } else {
      let formData = {
        ...this.form.value,
        name:this.form.value.name
      }

      this.dialogRef.close(formData)
    }

  }

  back() {
    this.dialogRef.close()
  }

  openModalAddNewHighway() {

    let data = {
      isEditMode: false
    }
    const dialog = this.dialog.open(CadHighwayModalComponent, {
      panelClass: ['filter-panel'],
      data: data
    })

    dialog.afterClosed().subscribe({
      next: (res: any) => {
        if (res) {
          this.loadingService.showLoading();
          this.highWayService.createHighway(res).pipe(
            finalize(() => {
              this.loadingService.hideLoading();
            })
          ).subscribe({
            next: (res: any) => {
              this.openSnackBar('Rodovia adicionada com sucesso.', 'sucess');

              this.dialogRef.close();
            }, error: (err: any) => {
              this.openSnackBar(err.error.message, 'error');
            }
          })
        }
      }
    })
  }

  openSnackBar(description: string, type: string) {
    let classSnack = '';
    switch (type) {
      case 'sucess':
        classSnack = 'snacbar-sucess';
        break;
      case 'warning':
        classSnack = 'snacbar-warning';
        break;
      case 'error':
        classSnack = 'snacbar-error';
        break;
    }
    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description: description, type: type },
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }


  onOptionSelectedHighwayHeader(event: any) {
    this.selectedOptionHighway = event.option.value
    this.searchControlHighwayHeader.setValue(this.selectedOptionHighway.name, { emitEvent: false });
    this.filteredOptionsHighway = [];
  }

}
